(function () {
    'use strict';

    var module = angular.module("imApp");

    module.factory("srCrewResourceService", ['p2DataTaskService', function (p2DataTaskService) {
        var service = {
            loadSrCrewResourceGet: function (srcrewresource_keyno, resource_id, srcrew_keyno) {
                return p2DataTaskService.call(1775, {
                    srcrewresource_keyno: srcrewresource_keyno,
                    resource_id: resource_id,
                    srcrew_keyno: srcrew_keyno
                });
            },
            save: function (resource) {
                return p2DataTaskService.call(1777, resource);
            },
            deleteObj: function (resource) {
                return p2DataTaskService.call(1776, resource);
            }
        };

        return service;
    }]);
})();